// reducer.js
import * as actionTypes from "./actionsTypes"

const initialState = {
  currentPage: 0,
  pageSize: 20,
  customFilters: [],
  value: "",
  sortField: "transaction_date",
  sortOrder: "desc",
  sorting: [],
  column: [],
  //Nouveau
  query: "",
  actif: {},
  selectedOptionFilters: null,
  selectedOptionId: null,
}

const FiltreBaseCalcul = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_VALUE_BASE_CALCUL:
      return {
        ...state,
        value: action.payload,
      }
    case actionTypes.SET_CURRENT_PAGE_BASE_CALCUL:
      return {
        ...state,
        currentPage: action.payload,
      }
    case actionTypes.SET_SORTING_BASE_CALCUL:
      return {
        ...state,
        sorting: action.payload,
      }
    case actionTypes.SET_SORT_FIELD_BASE_CALCUL:
      return {
        ...state,
        sortField: action.payload,
      }
    case actionTypes.SET_PAGE_SIZE_BASE_CALCUL:
      return {
        ...state,
        pageSize: action.payload,
      }
    case actionTypes.SET_ORDER_BASE_CALCUL:
      return {
        ...state,
        sortOrder: action.payload,
      }
    case actionTypes.SET_CUSTOM_FILTERS_BASE_CALCUL:
      return {
        ...state,
        customFilters: action.payload,
      }
    case actionTypes.SET_COLUMN_BASE_CALCUL:
      return {
        ...state,
        column: action.payload,
      }
    //
    case actionTypes.SET_QUERY_BASE_CALCUL:
      return {
        ...state,
        query: action.payload,
      }
    case actionTypes.SET_ACTIF_BASE_CALCUL:
      return {
        ...state,
        actif: action.payload,
      }
    case actionTypes.SET_SELECTED_OPTION_FILTERS_BASE_CALCUL:
      return {
        ...state,
        selectedOptionFilters: action.payload,
      }
    case actionTypes.SET_SELECTED_OPTION_ID_BASE_CALCUL:
      return {
        ...state,
        selectedOptionId: action.payload,
      }
    default:
      return state
  }
}

export default FiltreBaseCalcul
